var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3967",
    "data-name": "Rectangle 3967",
    width: 24,
    height: 24,
    transform: "translate(17196 -3697)",
    fill: "#e03e6a",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_423",
    "data-name": "Mask Group 423",
    transform: "translate(-17196 3697)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M13.714,9.115a5.155,5.155,0,0,1,4.439,7.755,5.249,5.249,0,0,1-1.874,1.85l-.85.5V24H12V19.216l-.85-.5a5.193,5.193,0,0,1-2.578-4.462,5.164,5.164,0,0,1,5.143-5.143m1.143-7.4H12.571V5.143h2.286ZM21.771,4.6,19.714,6.658l1.6,1.6L23.371,6.2l-1.6-1.6ZM5.658,4.6l-1.6,1.6L6.114,8.258l1.6-1.6L5.657,4.6Zm8.056,2.8a6.86,6.86,0,0,0-3.429,12.8v5.514h6.857V20.2A6.86,6.86,0,0,0,13.714,7.4Zm12,5.714H22.286V15.4h3.429Zm-20.571,0H1.714V15.4H5.143Z",
    transform: "translate(17194.285 -3698.714)",
    fill: "#e03e6a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightR);
export default __webpack_public_path__ + "static/media/light_r.b28d54cfb78645332b26bde2ea01113e.svg";
export { ForwardRef as ReactComponent };